import _ from 'lodash';
import { TravelTypes } from '../constants';
import formatStateroomsForRequest from './formatters/formatStateroomsForRequest';

const formatTripRequest = ({ trip, staterooms, city, isBrochurePage, tripRoomSearchInput }) => {
  let { cruiseItinerary } = trip;
  if (trip.tripSegments && trip.tripSegments.length) {
    const matchingSeg = _.find(
      trip.tripSegments,
      (ts) => ts && ts.itinerary && ts.itinerary.mode === TravelTypes.cruise,
    );
    if (matchingSeg && matchingSeg.itinerary) {
      cruiseItinerary = matchingSeg.itinerary;
    }
  }
  const roomSearchInput = isBrochurePage
    ? tripRoomSearchInput
    : staterooms.map((i) => {
        const cruiseLineId =
          cruiseItinerary &&
          cruiseItinerary.itineraryDetail &&
          cruiseItinerary.itineraryDetail.cruiseLine.cruiseLineId;
        const stateroom = formatStateroomsForRequest(i, cruiseLineId);
        return {
          adults: i.adults,
          seniors: i.seniors,
          children: i.children,
          lapInfants: i.lapInfants,
          seatInfants: i.seatInfants,
          customerEmail: stateroom.customerEmail,
          customerId: stateroom.customerId,
          pastPassengerNumber: stateroom.pastPassengerNumber,
          passengerOccupation: stateroom.passengerOccupation,
          passengerFirstName: stateroom.passengerFirstName,
          passengerMiddleName: stateroom.passengerMiddleName,
          passengerLastName: stateroom.passengerLastName,
        };
      });

  const tripSegments = trip?.tripSegments?.map((s) =>
    s?.itinerary?.mode === TravelTypes.carrental && !Number.isNaN(+s?.itinerary?.id)
      ? { ...s, itinerary: { ...s.itinerary, id: +s.itinerary.id } }
      : s,
  );

  return {
    ...trip,
    tripSegments,
    roomSearchInput,
    passengerCity: city
      ? {
          code: city.value,
          name: city.label,
        }
      : undefined,
  };
};

export default formatTripRequest;
